export const UI_OPTION_KEYS = {
  SEARCH_TYPE: 'SEARCH_TYPE',
  FUND_SEARCH_CATEGORY: 'FUND_SEARCH_CATEGORY',
  PORTFOLIO_SEARCH_CATEGORY: 'PORTFOLIO_SEARCH_CATEGORY',
  PROFILER_SEARCH_CATEGORY: 'PROFILER_SEARCH_CATEGORY',
  INDIVIDUALS_SEARCH_CATEGORY: 'INDIVIDUALS_SEARCH_CATEGORY',
  CONTACT_FILTER_IS_SHAREHOLDER: 'CONTACT_FILTER_IS_SHAREHOLDER',
  CONTACT_FILTER_AGE: 'CONTACT_FILTER_AGE',
  PROFILER_HEATMAP_SIZE: 'PROFILER_HEATMAP_SIZE',
  PROFILER_HEATMAP_COLOR_CODING: 'PROFILER_HEATMAP_COLOR_CODING',
  PROFILER_LISTING_STATUS: 'PROFILER_LISTING_STATUS',
  PROFILER_OWNERSHIP_STRUCTURE: 'PROFILER_OWNERSHIP_STRUCTURE',
  PROFILER_OWNERSHIP_BASIS: 'PROFILER_OWNERSHIP_BASIS'
};
